export default "__VITE_ASSET__HeUBhO1o__"